"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatTime = void 0;

var formatTime = function formatTime(timeInSeconds) {
  var minutes = Math.floor(timeInSeconds / 60);
  var seconds = Math.floor(timeInSeconds - minutes * 60);
  return "".concat(String(minutes), ":").concat(String(seconds).padStart(2, '0'));
};

exports.formatTime = formatTime;